export const isMobile = () => {
    if(window.innerWidth<900 || navigator.userAgent.includes("SamsungBrowser"))
        return true;
    return false
} 
export default isMobile